module.exports = __webpack_public_path__ + "static/media/ele-tutor.a4fa6adb.jpg";